import React, { useMemo, useState } from 'react';

import DeleteIcon from '../../../../assets/icons/DeleteIcon';
import EditIcon from '../../../../assets/icons/EditIcon';
import DoneIcon from '../../../../assets/icons/CheckIcon';
import TagIcon from '../../../../assets/icons/TagIcon';

import ActionIconButton from '../../../shared/ActionIconButton';
import ColorButton from '../../../shared/ColorButton';
import MinimizedSelect from '../../../shared/MinimizedSelect';

const VALUES = ['GTIN', 'REF', 'LOT', 'EXP', 'DESC'];

const SplitModalUsageItem = (props) => {
  const { item, onApproveClick, onSave, onDelete, orderClosed, users = [], tags = [] } = props;
  const { id, values = [], quantity, approved, userId } = item;

  const getValue = (values = [], key) => {
    if (!values || !values.length || !key) {
      return '';
    }

    const value = values?.find((item) => item.label === key);
    return value?.value || '';
  };

  const [editMode, toggleEditMode] = useState(false);

  const [data, setData] = useState({
    GTIN: getValue(values, 'GTIN'),
    REF: getValue(values, 'REF'),
    LOT: getValue(values, 'LOT'),
    EXP: getValue(values, 'EXP'),
    DESC: getValue(values, 'DESC'),
    quantity,
  });

  const onSaveClick = () => {
    onSave({
      ...item,
      gtin: data.GTIN || '',
      ref: data.REF || '',
      lot: data.LOT || '',
      exp: data.EXP || '',
      desc: data.DESC || '',
      quantity: data.quantity || '',
      tag: data.tag || ''
    });
    toggleEditMode(false);
  };

  const userName = useMemo(() => {
    if (!userId) {
      return '';
    }
    const user = users?.find((u) => u.uid === userId);
    return user ? `${user.firstName} ${user.lastName}` : '';
  }, [userId, users])

  const tag = useMemo(() => tags?.find((t) => t.id === item.tag), [item, tags]);

  return (
    <div className='' style={{ borderColor: tag?.color || '#eeeeee' }}>
      <div>
        {!!tag && (
          <div style={{ color: tag.color }} className='m-b-sm font-bold'>
            {tag.name}
          </div>
        )}
        {editMode && (
          <div className={`d-flex ${editMode ? 'm-b-md' : 'm-b-sm'}`} style={{ alignItems: editMode ? 'center' : 'flex-start' }}>
            <div className='font-bold' style={{ minWidth: 60 }}>
              <TagIcon />
            </div>
            <div style={{ width: '100%' }}>
              <MinimizedSelect
                value={data.tag}
                onChange={(value) => setData({ ...data, tag: value })}
                options={[{ key: 'empty', label: 'No Tags', value: '' }, ...tags?.map((tag) => ({
                  key: tag.id,
                  value: tag.id,
                  label: tag.name,
                  icon: <TagIcon color={tag.color} fontSize='small' />,
                }))]}
              />
            </div>
          </div>
        )}
        {VALUES?.map((label) => {
          if (getValue(values, label) || editMode) {
            return (
              <div className={`d-flex ${editMode ? 'm-b-md' : 'm-b-sm'}`} style={{ alignItems: editMode ? 'center' : 'flex-start' }}>
                <div className='font-bold' style={{ minWidth: 60 }}>
                  {label}
                </div>
                <div style={{ wordBreak: 'break-word', width: '100%' }}>
                  {editMode ? (
                    <input
                      className='minimized-input'
                      type='text'
                      value={data[label]}
                      onChange={(e) => setData({ ...data, [label]: e.target?.value })}
                    />
                  ) : (
                    getValue(values, label)
                  )}
                </div>
              </div>
            );
          }
          return null;
        })}
        <div className='d-flex flex-start'>
          <div className='font-bold' style={{ minWidth: 60 }}>QTY</div>
          {editMode ? (
            <input
              className='minimized-input'
              type='number'
              value={data.quantity}
              onChange={(e) => setData({ ...data, quantity: e.target?.value })}
            />
          ) : (
            <span>{quantity}</span>
          )}
        </div>

        <div className='d-flex space-between align-end'>
          {!!userName ? (
            <div>
              <div className='m-t-md font-bold font-size-sm'>Added by</div>
              <div className=''>{userName}</div>
            </div>
          ) : <div />}

          <div className='d-flex space-between align-end'>
            <div className='pointer'>
              {!orderClosed && (
                editMode ? (
                  <div className='d-flex'>
                    <div className='m-r-md'>
                      <ActionIconButton
                        onClick={() => onDelete(id)}
                        color="red"
                        className='m-r-md'
                        tooltip="Delete"
                        size='small'
                      >
                        <DeleteIcon fontSize='small' />
                      </ActionIconButton>
                    </div>
                    <div>
                      <ActionIconButton
                        onClick={onSaveClick}
                        color="blue"
                        tooltip="Save"
                        size='small'
                      >
                        <DoneIcon fontSize='small' />
                      </ActionIconButton>
                    </div>
                  </div>
                ) : (
                  <ActionIconButton
                    onClick={() => toggleEditMode(true)}
                    color="blue"
                    tooltip="Edit"
                    size='small'
                  >
                    <EditIcon fontSize='small' />
                  </ActionIconButton>
                )
              )}
            </div>
            <div>
              <ColorButton
                onClick={() => onApproveClick(id, !approved)}
                color={approved ? 'green' : 'blue'}
                text={approved ? 'Approved' : 'Approve'}
                className='m-l-lg'
                height={30}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SplitModalUsageItem;
